import PropTypes from 'prop-types'
import React from 'react'

import { Redirect, Route, Switch } from 'react-router-dom'
import { isAuthenticated } from '../services/auth'

import AllQrCode from '../pages/AllQrCode'
import ChallengeForm from '../pages/ChallengeForm'
import ChallengeList from '../pages/ChallengeList'
import ChooseHighlightType from '../pages/ChooseHighlightType'
import ClippingDetails from '../pages/ClippingDetails'
import ClippingForm from '../pages/ClippingForm'
import ClippingPage from '../pages/ClippingPage'
import ClippingPartner from '../pages/ClippingPartner'
import CommentsManagerPage from '../pages/CommentsManagerPage'
import CommunicationMaterials from '../pages/CommunicationMaterials'
import CouponsForm from '../pages/CouponsForm'
import CouponsList from '../pages/CouponsList'
import CouponsPage from '../pages/CouponsPage'
import CourtesiesList from '../pages/CourtesiesList'
import CourtesyForm from '../pages/CourtesyForm'
import CustomerService from '../pages/CustomerService'
import Dashboard from '../pages/Dashboard'
import EventForm from '../pages/EventForm'
import EventsList from '../pages/EventsList'
import HighLightsList from '../pages/HighLightsList'
import HomePartners from '../pages/HomePartners'
import HomeValidations from '../pages/HomeValidations'
import ImagesManagerPage from '../pages/ImagesManagerPage'
import LandingPagesForm from '../pages/LandingPagesForm'
import LandingPagesList from '../pages/LandingPagesList'
import MomentForm from '../pages/MomentForm'
import MomentsList from '../pages/MomentsList'
import Movies from '../pages/Movie'
import MovieForm from '../pages/MovieForm'
import MovieSession from '../pages/MovieSession'
import MovieSessionForm from '../pages/MovieSessionForm'
import MovieTicketsForm from '../pages/MovieTicketsForm'
import MovieTicketsList from '../pages/MovieTicketsList'
import MovieTicketsPurchases from '../pages/MovieTicketsPurchases'
import MuralForm from '../pages/MuralForm'
import MuralList from '../pages/MuralList'
import NewsForm from '../pages/NewsForm'
import NewsList from '../pages/NewsList'
import NotificationsPage from '../pages/NotificationsPage'
import OfferingPage from '../pages/OfferingPage'
import PartnerForm from '../pages/PartnerForm'
import PartnersList from '../pages/PartnersList'
import PaymentsList from '../pages/PaymentsList'
import PaymentsPage from '../pages/PaymentsPage'
import QuizForm from '../pages/QuizForm'
import QuizList from '../pages/QuizList'
import Report from '../pages/Report'
import ScriptForm from '../pages/ScriptForm'
import ScriptsList from '../pages/ScriptsList'
import TestimonialPage from '../pages/TestimonialsPage'
import WhiteLabelForm from '../pages/ThemesForm'
import WhiteLabelPage from '../pages/ThemesPage'
import UnitiesList from '../pages/UnitiesList'
import UnityForm from '../pages/UnityForm'
import UserValidate from '../pages/UserValidate'
import UsersPage from '../pages/UsersPage'
import VoucherForm from '../pages/VoucherForm'
import VoucherList from '../pages/VoucherList'

function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={props =>
        isAuthenticated() ? (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  )
}

function Routes() {
  return (
    <Switch>
      <PrivateRoute path="/dashboard" component={Dashboard} />
      <PrivateRoute path="/clipping" component={ClippingPage} />
      <PrivateRoute path="/clippingdetails" component={ClippingDetails} />
      <PrivateRoute path="/clippingform" component={ClippingForm} />
      <PrivateRoute path="/clippingpartner" component={ClippingPartner} />
      <PrivateRoute path="/highlighttype" component={ChooseHighlightType} />
      <PrivateRoute path="/partnerslist" component={PartnersList} />
      <PrivateRoute path="/partnerform" component={PartnerForm} />
      <PrivateRoute path="/courtesieslist" component={CourtesiesList} />
      <PrivateRoute path="/courtesyform" component={CourtesyForm} />
      <PrivateRoute path="/unityform" component={UnityForm} />
      <PrivateRoute path="/unitieslist" component={UnitiesList} />
      <PrivateRoute path="/eventslist" component={EventsList} />
      <PrivateRoute path="/eventform" component={EventForm} />
      <PrivateRoute path="/uservalidate" component={UserValidate} />
      <PrivateRoute path="/report" component={Report} />
      <PrivateRoute path="/scripts" component={ScriptsList} />
      <PrivateRoute path="/scriptform" component={ScriptForm} />
      <PrivateRoute path="/moments" component={MomentsList} />
      <PrivateRoute path="/momentform" component={MomentForm} />
      <PrivateRoute path="/challenge" component={ChallengeList} />
      <PrivateRoute path="/challengeform" component={ChallengeForm} />
      <PrivateRoute path="/notifications" component={NotificationsPage} />
      <PrivateRoute path="/users" component={UsersPage} />
      <PrivateRoute path="/coupons" component={CouponsPage} />
      <PrivateRoute path="/couponsform" component={CouponsForm} />
      <PrivateRoute path="/qrcode" component={AllQrCode} />
      <PrivateRoute path="/images" component={ImagesManagerPage} />
      <PrivateRoute path="/comments" component={CommentsManagerPage} />
      <PrivateRoute path="/themes" component={WhiteLabelPage} />
      <PrivateRoute path="/themesform" component={WhiteLabelForm} />
      <PrivateRoute path="/testimonials" component={TestimonialPage} />
      <PrivateRoute path="/offeringsetup" component={OfferingPage} />
      <PrivateRoute path="/murallist" component={MuralList} />
      <PrivateRoute path="/muralform" component={MuralForm} />
      <PrivateRoute path="/highlightslist" component={HighLightsList} />
      <PrivateRoute path="/newslist" component={NewsList} />
      <PrivateRoute path="/newsform" component={NewsForm} />
      <PrivateRoute path="/quiz" component={QuizList} />
      <PrivateRoute path="/quizform" component={QuizForm} />
      <PrivateRoute path="/payments" component={PaymentsPage} />
      <PrivateRoute path="/paymentslist" component={PaymentsList} />
      <PrivateRoute path="/couponslist" component={CouponsList} />
      <PrivateRoute path="/voucherlist" component={VoucherList} />
      <PrivateRoute path="/voucherform" component={VoucherForm} />
      <PrivateRoute path="/home-validations" component={HomeValidations} />
      <PrivateRoute path="/home-partners" component={HomePartners} />
      <PrivateRoute path="/movies" component={Movies} />
      <PrivateRoute path="/movieForm" component={MovieForm} />
      <PrivateRoute path="/sessions" component={MovieSession} />
      <PrivateRoute path="/movieSessionForm" component={MovieSessionForm} />
      <PrivateRoute path="/movieticketslist" component={MovieTicketsList} />
      <PrivateRoute path="/movieticketsform" component={MovieTicketsForm} />
      <PrivateRoute path="/movieticketspurchases" component={MovieTicketsPurchases} />
      <PrivateRoute path="/communication-materials" component={CommunicationMaterials} />
      <PrivateRoute path="/customer-service" component={CustomerService} />
      <PrivateRoute path="/landing-pages" component={LandingPagesList} />
      <PrivateRoute path="/landingpageform" component={LandingPagesForm} />
    </Switch>
  )
}

PrivateRoute.defaultProps = {
  location: Dashboard
}

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  /* eslint react/forbid-prop-types:0 */
  location: PropTypes.any
}

export default Routes
